/* eslint-disable max-len */
var ICON_UI_CHEVRON_UP = {
  v2: true,
  "default": 'M0.75 17.189L11.47 6.47C11.5396 6.40033 11.6222 6.34507 11.7131 6.30736C11.8041 6.26965 11.9016 6.25024 12 6.25024C12.0984 6.25024 12.1959 6.26965 12.2869 6.30736C12.3778 6.34507 12.4604 6.40033 12.53 6.47L23.25 17.189',
  globetrotter: 'M1.875 17.0625L12 6.9375L22.125 17.0625'
};

export { ICON_UI_CHEVRON_UP };
//# sourceMappingURL=ICON_UI_CHEVRON_UP.js.map
